import base from './base'

export default {
    ...base,
    title: {
        type: ['undefined', 'string']
    },
    days_count: {
        type: ['number'],
        default: 0,
    },
    price: {
        type: ['number'],
        default: 0,
    },
    currency: {
        type: ['undefined', 'string']
    },
    discount_percent: {
        type: ['float'],
        default: 0,
    },
    tax_pct: {
        type: ['float'],
        default: 0,
    },
    view: {
        type: ['boolean'],
        default: false
    },
    // discount_price: {
    //   type: ['number'],
    //   default: 0,
    // },
}